export { default as ReportIcon } from '~icons/ion/flag';
